import { render } from "./PieChartReport.vue?vue&type=template&id=549b8e2a&scoped=true"
import script from "./PieChartReport.vue?vue&type=script&lang=js"
export * from "./PieChartReport.vue?vue&type=script&lang=js"

import "./PieChartReport.vue?vue&type=style&index=0&id=549b8e2a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549b8e2a"]])

export default __exports__